import { useQuery } from '@tanstack/react-query';
import { radarFramesResponseSchema } from '@repo/shared';
import { apiRequest } from '../../lib/api';

/** RainViewer publishes a new frame every ~10 minutes. */
const REFETCH_INTERVAL_MS = 60_000;

/**
 * The rolling list of radar frames. Polled so a tab left open keeps catching
 * new frames as they're published; the Worker's edge cache absorbs the polling.
 */
export function useRadarFrames() {
  return useQuery({
    queryKey: ['radar', 'frames'],
    queryFn: () => apiRequest('/radar/frames', radarFramesResponseSchema),
    refetchInterval: REFETCH_INTERVAL_MS,
    staleTime: REFETCH_INTERVAL_MS / 2,
  });
}
